import { MedicalInformationCountByType } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { assertUnreachable, PromiseVoidFunction } from '@dreryk/react-common';

import { MedicalDataCategoriesSidePanelList } from './MedicalDataCategoriesSidePanelList';
import { MedicalDataSidePanelRegularContent } from './MedicalDataSidePanelRegularContent';
import { ChronicDiseaseSidePanelContent } from './chronicDisease/ChronicDiseaseSidePanelContent';
import { DiagnosisSidePanelContent } from './diagnosis/DiagnosisSidePanelContent';
import { GynecologicalInterviewSidePanelContent } from './gynecologicalInterview/GynecologicalInterviewSidePanelContent';

type MedicalDataSidePanelContentProps = {
   readonly patientId: number;
   readonly medicalData: MedicalInformationCountByType[] | undefined;
   readonly activeMedicalDataItem?: MedicalInformationCountByType;
   readonly onItemHeaderClick: (item: MedicalInformationCountByType | undefined) => void;
   readonly onMedicalDataAccessAuthorizationUpdate: PromiseVoidFunction;
};

export const MedicalDataSidePanelContent = (props: MedicalDataSidePanelContentProps): JSX.Element => {
   if (props.activeMedicalDataItem?.type === undefined) {
      return (
         <MedicalDataCategoriesSidePanelList
            medicalData={props.medicalData}
            onItemHeaderClick={props.onItemHeaderClick}
         />
      );
   }

   switch (props.activeMedicalDataItem?.type) {
      case 'GYNECOLOGICAL_INTERVIEW':
         return (
            <GynecologicalInterviewSidePanelContent
               patientId={props.patientId}
               onMedicalDataAccessAuthorizationUpdate={props.onMedicalDataAccessAuthorizationUpdate}
            />
         );
      case 'CHRONIC_DISEASE':
         return (
            <ChronicDiseaseSidePanelContent
               patientId={props.patientId}
               onMedicalDataAccessAuthorizationUpdate={props.onMedicalDataAccessAuthorizationUpdate}
            />
         );
      case 'DIAGNOSIS':
         return <DiagnosisSidePanelContent patientId={props.patientId} />;
      case 'ALLERGY':
      case 'ANTHROPOMETRY':
      case 'RISK_FACTOR':
      case 'HOSPITALIZATION':
      case 'MEDICAL_IMAGING':
      case 'MEDICAL_CONSULTATION':
      case 'REHABILITATION':
      case 'REFERRAL':
      case 'TREATMENT':
      case 'OTHER':
      case 'ANALYTICAL_TEST_RESULT':
         return (
            <MedicalDataSidePanelRegularContent
               patientId={props.patientId}
               activeMedicalDataItem={props.activeMedicalDataItem}
               onMedicalDataAccessAuthorizationUpdate={props.onMedicalDataAccessAuthorizationUpdate}
            />
         );
      default:
         return assertUnreachable(props.activeMedicalDataItem?.type);
   }
};
